var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobIconBzs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.899 0.860352C6.62095 1.15327 0 7.95641 0 16.306C0 21.5271 2.58894 26.1435 6.55311 28.9416V22.4555C5.34461 20.7093 4.63663 18.5903 4.63663 16.306C4.63663 10.5175 9.18255 5.79081 14.899 5.50121V0.860352Z",
    fill: "#19253D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1798 0.87207H16.2248L16.2248 8.06335L16.2248 31.7419C18.75 31.6176 21.1158 30.8872 23.1798 29.6932L23.1798 26.4133V0.87207ZM24.5708 9.81421H29.4824C30.397 11.7879 30.9075 13.9871 30.9075 16.3055C30.9075 21.431 28.4125 25.9738 24.5708 28.7855V9.81421ZM14.8339 18.562V31.7488C12.3137 31.6496 9.94852 30.947 7.87891 29.7815L7.87891 18.562L14.8339 18.562Z",
    fill: "#27AE60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobIconBzs);
export default __webpack_public_path__ + "static/media/mob-icon-bzs.9dae2431cc492ba9127c8501689b44ef.svg";
export { ForwardRef as ReactComponent };